module.exports = __webpack_public_path__ + "img/tech.6ab609a6.svg";